import request from '@/utils/request';
/**
 * 户列表查询
 */
export function queryUserInfoList(data) {
  return request({
    url: '/sys/user/list',
    method: 'post',
    data: data
  });
}
/**
 * 户列表查询 无Loading版本
 */
export function queryUserInfoListNoLoading(data) {
  return request({
    url: 'api/user/queryUserInfoList',
    method: 'post',
    data: data
  }, '', 'no-loading');
}
/** 
 * 停用用户
 */
function frozen(data) {
  return request({
    url: 'api/user/frozen',
    method: 'post',
    data: data
  });
}
/** 
 * 启用用户
 */
function userUsing(data) {
  return request({
    url: 'api/user/using',
    method: 'post',
    data: data
  });
}
/** 
 * 启用/禁用用户
 */
export function frozenOrUsing(id) {
  var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Promise(function (resolve, reject) {
    if (flag) {
      resolve(userUsing(id));
    } else {
      resolve(frozen(id));
    }
  });
}

/**
 * 导出
 */
export function exportUser(data) {
  return request({
    url: 'api/user/export',
    method: 'post',
    responseType: 'blob',
    data: data
  });
}

/**
 * 初始化角色信息
 */
export function getRoleInfoByName() {
  return request({
    url: 'api/user/getRoleInfoByName',
    method: 'post'
  });
}
/**
 * 新增用户
 */
function add(data) {
  return request({
    url: 'api/user/addUserGroupRole',
    method: 'post',
    data: data
  });
}

/**
 * 编辑用户
 */
function edit(data) {
  return request({
    url: 'api/user/editUserGroupRole',
    method: 'post',
    data: data
  });
}

/**
 * 集合新增与编辑
 * @params status  1:新增  2：编辑
 */
export function addOrEditor(data) {
  var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return new Promise(function (resolve, reject) {
    if (status === 1) {
      resolve(add(data));
    } else {
      resolve(edit(data));
    }
  });
}

/**
 * 查看用户信息
 * 
 */
export function viewUserInfo(data) {
  return request({
    url: 'api/user/queryUserInfo',
    method: 'post',
    data: data
  });
}
/**
 * 修改密码
 * @params id password
 */
export function updatePass(data) {
  return request({
    url: 'api/user/resetPassword',
    method: 'post',
    data: data
  });
}

/**
 * 初始化部门列表信息
 * api/user/getGroupList
 */
export function getGroupList() {
  return request({
    url: 'api/user/getGroupList',
    method: 'post'
  });
}
// 根据应用查询role
export function queryRoleByApp(data) {
  return request({
    url: '/api/user/queryRole',
    method: 'POST',
    data: data,
    baseURL: process.env.VUE_APP_BASE_API
  });
}
// 获取角色下拉表
export function getRoleList() {
  return request({
    url: '/common/dropdown/roles',
    method: 'get'
  });
}

// 新增用户
export function addUser(data) {
  return request({
    url: '/sys/user/add',
    method: 'POST',
    data: data,
    baseURL: process.env.VUE_APP_BASE_API
  });
}

// 编辑用户
export function editUser(data) {
  return request({
    url: '/sys/user/edit',
    method: 'POST',
    data: data,
    baseURL: process.env.VUE_APP_BASE_API
  });
}

// 经销商下拉数据
export function getDealers() {
  return request({
    url: '/common/dropdown/dealers',
    method: 'get',
    baseURL: process.env.VUE_APP_BASE_API
  });
}

// 用户详情
export function getUserDetail(data) {
  return request({
    url: '/sys/user/detail',
    method: 'post',
    data: data,
    baseURL: process.env.VUE_APP_BASE_API
  });
}

// 用户删除
export function userDelete(data) {
  return request({
    url: '/sys/user/delete',
    method: 'post',
    data: data,
    baseURL: process.env.VUE_APP_BASE_API
  });
}

// 密码重置
export function resetPwd(data) {
  return request({
    url: '/sys/user/reset/pwd',
    method: 'post',
    data: data,
    baseURL: process.env.VUE_APP_BASE_API
  });
}

// 导出
export function userExcel(data) {
  return request({
    url: '/sys/user/excel',
    method: 'post',
    data: data,
    responseType: 'blob',
    baseURL: process.env.VUE_APP_BASE_API
  });
}

// 修改密码
export function changePwd(data) {
  return request({
    url: '/user/changePwd',
    method: 'post',
    data: data,
    baseURL: process.env.VUE_APP_BASE_API
  });
}